import { useEffect, useRef } from "react";

const partners = [
  "Genial Investimentos",
  "XP Investimentos",
  "BTG Pactual",
  "Santander",
];

const PartnersCarousel = () => {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    let animationId: number;
    let position = 0;

    const animate = () => {
      position += 0.5;
      if (position >= el.scrollWidth / 2) {
        position = 0;
      }
      el.scrollLeft = position;
      animationId = requestAnimationFrame(animate);
    };

    animationId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationId);
  }, []);

  const duplicated = [...partners, ...partners, ...partners];

  return (
    <section className="bg-primary py-6 overflow-hidden">
      <div
        ref={scrollRef}
        className="flex items-center gap-12 sm:gap-16 overflow-hidden whitespace-nowrap"
      >
        {duplicated.map((name, i) => (
          <span
            key={i}
            className="text-primary-foreground/80 text-lg sm:text-xl font-semibold tracking-wide shrink-0 px-4"
          >
            {name}
          </span>
        ))}
      </div>
    </section>
  );
};

export default PartnersCarousel;
